import request from '@/utils/request';

const path = 'api/v1';

const testCountReportGet = data => request({
  url: `${path}/report/testcount`,
  method: 'Get',
  params: data,
});



export {
  testCountReportGet,
};
